<template>
  <div
    class="iconview"
    :style="{
      width: boxSize > 0 ? boxSize + 'px' : size + 'px',
      height: boxSize > 0 ? boxSize + 'px' : size + 'px',
      backgroundColor: fill,
      WebkitMaskImage: `url(${iconUrl})`,
      maskImage: `url(${iconUrl})`,
      WebkitMaskRepeat: 'no-repeat',
      maskRepeat: 'no-repeat',
      WebkitMaskSize: 'contain',
      maskSize: 'contain',
      WebkitMaskPosition: 'center',
      maskPosition: 'center',
      display: 'inline-block'
    }"
  ></div>
</template>

<script>
export default {
  name: 'SvgIcon',
  props: {
    svgname: {
      type: String,
      default: 'ic_add1'
    },
    size: {
      type: Number,
      default: 20
    },
    fill: {
      type: String,
      default: '#666666'
    },
    boxSize: {
      type: Number,
      default: 0
    }
  },
  computed: {
    iconUrl() {
      // 这里假设 SVG 文件放在 /svgfiles 目录下，路径根据你项目实际情况修改
      return `/svgfiles/${this.svgname}.svg`;
    }
  }
}
</script>

<style scoped>
.iconview {
  /* 这里不需要额外设置样式，全部用内联样式控制 */
}
</style>
